import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop(){
    const location = useLocation();
  useEffect(() => {
    if (!location.hash) {
      // No hash → scroll to top
      window.scrollTo({ top: 0 });
    }
  }, [location.pathname]); // Only run when page changes
}